// extracted by mini-css-extract-plugin
export default {"mainContainer":"style_mainContainer__MEAYc","faqHeader":"style_faqHeader__uDkRr"};